export default "__VITE_ASSET__82ef85b3__"